var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('div',{staticClass:"boxError"},[_c('h1',[_vm._v("404")]),_c('p',[_vm._v("\n            Página não encontrada : ( "),_c('br'),_c('span',{on:{"click":_vm.toHome}},[_vm._v("Clique aqui")]),_vm._v(" para acessar a página inicial\n        ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }